import {Component, OnInit} from '@angular/core';
import {Column} from '../../share/models/column';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderFormService} from '../../services/order-form.service';
import {PopConfiguration} from '../../models/pop-configuration';
import {PopConfigurationGroup} from '../../models/pop-configuration-group';
import {OrderForm} from '../../models/order-form';
import * as _ from 'lodash';
import {ExchangeProduct} from '../../models/exchange-product';
import {OverlayPanel} from 'primeng/overlaypanel';
import {saveAs} from 'file-saver';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {SelectItem} from '../../models/select-item';
import {QDJiraIssue} from '../../models/qdJiraIssue';
import {JiraService} from '../../services/jira.service';
import {environment} from '../../../environments/environment';
import {UserLogged} from '../../models/userLogged';
import {EtreeService} from '../../services/etree.service';
import {TechnicalPopService} from '../../services/technical-pop.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-qed-profile',
  templateUrl: './qed-profile.component.html',
  styleUrls: ['./qed-profile.component.scss']
})

export class QedProfileComponent implements OnInit {
  loading = false;
  orderFormsCols: Column[];
  orderForms: OrderForm[];
  selectedOrderForms: OrderForm[];
  exProducts: ExchangeProduct[] = [];
  defaultExProducts: ExchangeProduct[] = [];
  rowGroupMetadata: any;
  selectedCPopCols: Column[];
  defaultSelectedCPopCols: Column[] = [];
  symbolsCols: Column[];
  historiesCols: Column[];
  companyName: string;
  companyUniqid: string;
  service: string;
  totalNbOfColumns: number;
  error: boolean;
  errorPopup: boolean;
  tabData: any;
  errorExport: boolean;
  selectedCol: any = null;
  selectedRowIndex: any = null;
  isJirapopUp = false;
  isSendToJiraDisabled = false;
  jiraCustomDescription = '';
  successCreateJira = false;
  jiraCreationError = false;
  itemsDataForDropDown: any [] = [];
  channelsDropDownList: SelectItem [] = [];
  displayJiraFeature: boolean;
  jiraIssueCode: string;
  jiraIssue: QDJiraIssue = new QDJiraIssue();
  itemsListForJira: any;
  loggedInUser: UserLogged;
  jiraLink: string;
  selectedItemsForJira: any;
  selectedChannelsForJira = [];
  itemsDropDownOptions: SelectItem[] = [];
  channelsDropDownOptions: SelectItem[] = [];
  selectedPriority = 'support';
  displayMulticastDialog = false;
  multicastGroups: any = {};
  showPopConfigButton = false;
  showConfigPopup = false;
  configsByPop: PopConfigurationGroup[] = [];
  loadingConfigs = false;
  configsFailed = false;
  copiedId: string = null;
  expandedTargetId: string = null;
  copiedStatus: string = null;
  showFullGrid = false;
  readonly Object = Object;
  participantsItemForJira: any[];
  selectedParticipantForJira: any;
  hasOnlyInactiveOF = false;
  isCondensedMode = true;

  channelCols = {
    QED: [
      {field: 'crossConnectId', header: 'Cross connect Id', width: '20%'},
      {field: 'channelCode', header: 'QED Channel', width: '20%'},
      {field: 'permissioningIp', header: 'Multicast Address', width: '20%'},
      {field: 'port', header: 'Port', width: '10%'},
      {field: 'platform', header: 'Platform', width: '20%'},
      {field: 'configStateStatus', header: 'Status', width: '20%'},
      {field: 'staticJoinSubnets', header: 'Static join subnets', width: '10%'}
    ],
    QHF: [
      {field: 'crossConnectId', header: 'Cross connect Id', width: '20%'},
      {field: 'channelCode', header: 'QHF Channel', width: '20%'},
      {field: 'permissioningIp', header: 'Multicast Address', width: '20%'},
      {field: 'port', header: 'Port', width: '15%'},
      {field: 'platform', header: 'Platform', width: '15%'},
      {field: 'configStateStatus', header: 'Status', width: '20%'},
      {field: 'staticJoinSubnets', header: 'Static join subnets', width: '10%'}
    ],
    QRD_L1: [
      {field: 'crossConnectId', header: 'Cross connect Id', width: '20%'},
      {field: 'permissioningId', header: 'Permissioning ID', width: '25%'},
      {field: 'channelCode', header: 'Channel', width: '20%'},
      {field: 'platform', header: 'Platform', width: '20%'},
      {field: 'configStateStatus', header: 'Status', width: '15%'},
    ],
    QRD_L3: [
      {field: 'crossConnectId', header: 'Cross connect Id', width: '20%'},
      {field: 'permissioningId', header: 'Permissioning ID', width: '20%'},
      {field: 'channelCode', header: 'Channel', width: '20%'},
      {field: 'permissioningIp', header: 'Multicast', width: '20%'},
      {field: 'port', header: 'Port', width: '10%'},
      {field: 'platform', header: 'Platform', width: '10%'},
      {field: 'configStateStatus', header: 'Status', width: '10%'},
      {field: 'staticJoinSubnets', header: 'Static join subnets', width: '10%'}
    ],
    NEWS: [
      {field: 'crossConnectId', header: 'Cross connect Id', width: '20%'},
      {field: 'permissioningId', header: 'Permissioning ID', width: '20%'},
      {field: 'channelCode', header: 'Channel', width: '20%'},
      {field: 'permissioningIp', header: 'Multicast', width: '20%'},
      {field: 'port', header: 'Port', width: '10%'},
      {field: 'platform', header: 'Platform', width: '15%'},
      {field: 'configStateStatus', header: 'Status', width: '15%'}
    ]
  };

  constructor(private authenticationService: AuthenticationService,
              private route: ActivatedRoute,
              protected utilsService: UtilsService,
              protected technicalPopService: TechnicalPopService,
              private _router: Router,
              private jiraService: JiraService,
              private etreeService: EtreeService,
              private orderFormService: OrderFormService,
              private titleService: Title) {
    this._router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.loggedInUser = this.authenticationService.userCurrent;
    this.displayJiraFeature = environment.displayJiraFeature;
    this.loading = true;
    this.error = false;
    this.errorPopup = false;
    this.initializeCols();
    this.route.paramMap.subscribe(params => {
      this.companyUniqid = params.get('companyUniqId');
      const service = params.get('service');
      this.service = service.toUpperCase();
      this.orderFormService.getOrderForms(this.companyUniqid, service).subscribe({
          next: orderForms => {
            this.companyName = orderForms['companyName'];
            this.showPopConfigButton = orderForms['hasPopConfigs']
              && (this.loggedInUser.permissions.isMckayUser || environment.displayPopConfigForClient);
            this.orderForms = orderForms['orderForms'].sort((x, y) => +new Date(y.executionDate) - +new Date(x.executionDate));
            this.selectedOrderForms = this.orderForms.filter(order => order.active === true);
            const products = [];
            Object.keys(orderForms['products']).map(function (key) {
              products.push(orderForms['products'][key]);
              return products;
            });
            this.exProducts = products;
            if (this.exProducts.length >= 12 && this.defaultSelectedCPopCols.length >= 12) {
              this.defaultExProducts = this.exProducts;
            } else {
              this.defaultExProducts = this.exProducts.filter(p => p.displayed);
            }
            this.initializeHeaders(orderForms['pops']);
            if (this.selectedOrderForms.length === 0) {
              this.selectedOrderForms.push(...this.orderForms);
              this.hasOnlyInactiveOF = true;
              _.forEach(this.selectedCPopCols, (pop) => {
                _.forEach(this.exProducts, (product) => {
                  if (product[pop.field]) {
                    _.forEach(product[pop.field], (item) => {
                      item.isDisplayed = true;
                    });
                  }
                });
              });
              if (!this.isAlreadyCondensed()) {
                this.displayedPopAndProdAccordingToVisibleItems();
              }
            }
            this.setItemsForJira();
            this.updateRowGroupMetaData();
            this.setTabTitle();
          }, error: () => {
            this.error = true;
            this.setTabTitle();
          }
        }
      );
      this.loadMulticasts();
    });
  }

  private initializeCols() {
    this.selectedCPopCols = [];
    this.orderFormsCols = [
      {field: 'status', header: 'Status', width: '8%'},
      {field: 'identificationNumber', header: 'Order Form Number', width: '12%'},
      {field: 'mrc', header: 'MRC', width: '9%'},
      {field: 'term', header: 'Term', width: '9%'},
      {field: 'invoiceFrequency', header: 'Invoice frequency', width: '11%'},
      {field: 'renewableStatus', header: 'Contract Renewable Status', width: '15%'},
      {field: 'renewalDate', header: 'Renewal Date', width: '11%'},
      {field: 'executionDate', header: 'Contract Execution Date', width: '11%'},
      {field: 'terminationDate', header: 'Contract Expiry Date', width: '11%'},
    ];
    this.initializePopupCols();
  }

  private initializeHeaders(pops) {
    this.totalNbOfColumns = 0;
    for (const pop of pops) {
      if (!this.selectedCPopCols.some(elem => elem.field === pop.cPop.uuid)) {
        this.totalNbOfColumns = this.totalNbOfColumns + 1;
        const col = {
          field: pop.cPop.uuid,
          header: pop.cPop.displayId,
          width: '1%',
          colspan: 1,
          value: pop.cPop.displayId,
          displayed: pop.cPop.displayed
        };
        this.selectedCPopCols.push(col);
        if (col.displayed) {
          this.defaultSelectedCPopCols.push(col);
        }
      }
    }
    if (this.isAlreadyCondensed()) {
      this.defaultSelectedCPopCols = this.selectedCPopCols;
    }
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (this.isAlreadyCondensed()) {
      this.defaultExProducts = this.exProducts;
    }
    if (this.defaultExProducts) {
      for (let i = 0; i < this.defaultExProducts.length; i++) {
        const rowData = this.defaultExProducts[i];
        const exchangeName = rowData.exchangeName;
        if (i === 0) {
          this.rowGroupMetadata[exchangeName] = {index: 0, size: 1};
        } else {
          const previousRowData = this.defaultExProducts[i - 1];
          const previousRowGroup = previousRowData.exchangeName;
          if (exchangeName === previousRowGroup) {
            this.rowGroupMetadata[exchangeName].size++;
          } else {
            this.rowGroupMetadata[exchangeName] = {index: i, size: 1};
          }
        }
      }
    }
    this.loading = false;
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  getCellClasses(exProduct: any, index: string): string {
    let iconClass = ' icon-common-';
    if (this.defaultSelectedCPopCols.length <= 6) {
      iconClass = ' small-icon-common-';
    }
    let cssClass = '';
    if (!exProduct[index]) {
      return cssClass;
    }
    if (exProduct[index].length > 0) {
      if (exProduct[index].find((prod) => prod['status'] === 'Configured' && prod['isDisplayed'])) {
        const itemTypeDisplayed = this.getItemTypeDisplayed(exProduct[index], 'Configured');
        cssClass = 'configured-status ' + itemTypeDisplayed + iconClass + this.service.toLowerCase();
      } else if (exProduct[index].find(prod => prod['status'] === 'Trial started' && prod['isDisplayed'])) {
        const itemTypeDisplayed = this.getItemTypeDisplayed(exProduct[index], 'Trial started');
        cssClass = 'trial-started-status ' + itemTypeDisplayed + iconClass + this.service.toLowerCase();
      } else if (exProduct[index].find(prod => prod['status'] === 'Trial ended' && prod['isDisplayed'])) {
        const itemTypeDisplayed = this.getItemTypeDisplayed(exProduct[index], 'Trial ended');
        cssClass = 'trial-ended-status ' + itemTypeDisplayed + iconClass + this.service.toLowerCase();
      } else if (exProduct[index].find(prod => prod['status'] === 'New' && prod['isDisplayed'])) {
        const itemTypeDisplayed = this.getItemTypeDisplayed(exProduct[index], 'New');
        cssClass = 'new-status ' + itemTypeDisplayed + iconClass + this.service.toLowerCase();
      } else if (exProduct[index].find(prod => prod['status'] === 'Deconfigured' && prod['isDisplayed'])) {
        const itemTypeDisplayed = this.getItemTypeDisplayed(exProduct[index], 'Deconfigured');
        cssClass = 'deconfigured-status ' + itemTypeDisplayed + iconClass + this.service.toLowerCase();
      }
      return cssClass;
    }
  }

  private getItemTypeDisplayed(product: any, status: string) {
    const itemTypes = this.getTypesList(product, status);
    let itemTypeDisplayed = itemTypes[0];
    if (itemTypes.length > 1) {
      itemTypeDisplayed = 'icon-multiple';
    }
    return itemTypeDisplayed;
  }

  private getTypesList(products: any, status: string): any[] {
    const productsFiltered = products.filter((prod) => prod['status'] === status && prod['isDisplayed']);
    const types = [];
    _.forEach(productsFiltered, (prod) => {
      const type = this.getItemType(prod);
      if (types.find(typ => {
        return typ.label === type.label;
      }) === undefined) {
        types.push(type.class);
      }
    });
    return types;
  }

  getIsDisplayed(exProduct: any, index: string): boolean {
    if (!exProduct[index]) {
      return false;
    }
    if (exProduct[index].length > 0) {
      return exProduct[index].some(elem => elem['isDisplayed'] === true);
    }
  }

  displayItem(event, exProduct: ExchangeProduct, col: any, overlayPanel: OverlayPanel) {
    const popInOngoingAnnouncements = [];
    const popInOngoingOutage = [];
    const popInOnGoingMaintenance = [];
    const popInAnnouncementCategory = [];
    const messagesUuid = [];
    this.initializePopupCols();
    if (!exProduct[col.field]) {
      return;
    }
    const itemsUuids = [];
    _.forEach(exProduct[col.field], (prod) => {
      popInOngoingAnnouncements[prod['uuid']] = false;
      popInOngoingOutage[prod['uuid']] = false;
      popInOnGoingMaintenance[prod['uuid']] = false;
      popInAnnouncementCategory[prod['uuid']] = prod['announcementCategory'];
      messagesUuid[prod['uuid']] = [];
      if (prod['isDisplayed'] && prod.uuid) {
        itemsUuids.push(prod.uuid);
      }
      if (prod['onGoingAnnouncement']) {
        popInOngoingAnnouncements[prod['uuid']] = true;
      }
      if (prod['onGoingOutage']) {
        popInOngoingOutage[prod['uuid']] = true;
      }
      if (prod['onGoingMaintenance']) {
        popInOnGoingMaintenance[prod['uuid']] = true;
      }
      if (prod['announcementMessages'] && prod['announcementMessages'].length > 0) {
        messagesUuid[prod['uuid']] = prod['announcementMessages'];
      }
    });
    if (itemsUuids.length === 0) {
      return;
    }
    const criteria = {
      companyUniqid: this.companyUniqid,
      service: this.service.toLowerCase(),
      itemUuids: itemsUuids
    };
    this.orderFormService.getOrderFormsItems(criteria).subscribe({
        next: result => {
          _.forEach(result['itemsData'], (res) => {
            this.tabData.push({
              'onGoingAnnouncement': popInOngoingAnnouncements[res['uuid']],
              'onGoingOutage': popInOngoingOutage[res['uuid']],
              'onGoingMaintenance': popInOnGoingMaintenance[res['uuid']],
              'announcementCategory': popInAnnouncementCategory[res['uuid']],
              'messagesUuid': messagesUuid[res['uuid']],
              'header': res.productName + ' @' + res.commercialPop,
              'status': res.status,
              'type': res.type,
              'typeImg': this.getTypeImg(res.type),
              'carrier': res.carrier,
              'hosting': res.hosting,
              'crossConnectId': res.crossConnectId,
              'vlanId': res.vlanId,
              'technicalPop': res.technicalPop,
              'channels': res.channels?.map(channel => ({...channel, layer: typeof channel.layer === 'number' ? `layer${channel.layer}` : channel.layer})),
              'symbols': res.symbols,
              'histories': res.histories,
            });
          });
          overlayPanel.toggle(event);
        }, error: () => {
          this.errorPopup = true;
        }
      }
    );
  }

  private initializePopupCols() {
    this.tabData = [];
    const symbolLabels: { [key: string]: string } = {
      QFD: 'QFD Symbol',
      QED: 'QED Symbol',
      QRD: 'QRD Symbol',
      QHF: 'QHF Symbol'
    };
    this.symbolsCols = [
      {field: 'assetClass', header: 'Asset Class', width: '20%'},
      {field: 'name', header: 'Name', width: '30%'},
      {field: 'maturity', header: 'Maturity', width: '20%'},
      {
        field: 'symbol',
        header: symbolLabels[this.service] || 'Symbol',
        width: '30%'
      }
    ];
    if (this.service === 'QFD') {
      this.symbolsCols.push({field: 'channelCode', header: 'QFD Channel', width: '30%'});
    }
    this.historiesCols = [
      {field: 'type', header: '', width: '30%'},
      {field: 'startDate', header: 'Start date', width: '30%'},
      {field: 'endDate', header: 'End date', width: '20%'}
    ];
  }

  onRowSelect(event) {
    const displayedPopUuids = new Set(this.defaultSelectedCPopCols.map(col => col.field));
    const displayedExchangeNames = new Set(this.defaultExProducts.map(prod => prod.exchangeName));
    _.forEach(this.selectedCPopCols, (pop) => {
      _.forEach(this.exProducts, (prod) => {
        if (prod[pop.field]) {
          _.forEach(prod[pop.field], (item) => {
            if (item['orderFormId'] === event.data.identificationNumber) {
              item.isDisplayed = true;
              // save the corresponding  pop(column) and product(row)
              displayedPopUuids.add(pop.field);
              displayedExchangeNames.add(prod.exchangeName);
            }
          });
        }
      });
    });
    // add the new pops to display
    this.defaultSelectedCPopCols = this.selectedCPopCols.filter(col =>
      displayedPopUuids.has(col.field)
    );
    // add the new products to display
    this.defaultExProducts = this.exProducts.filter(prod =>
      displayedExchangeNames.has(prod.exchangeName)
    );
    this.updateRowGroupMetaData();
  }


  onRowUnselect(event) {
    _.forEach(this.selectedCPopCols, (pop) => {
      _.forEach(this.exProducts, (prod) => {
        if (prod[pop.field]) {
          _.forEach(prod[pop.field], (item) => {
            if (item['orderFormId'] === event.data.identificationNumber) {
              item.isDisplayed = false;
            }
          });
        }
      });
    });

    // Update the sets of displayed POP uuids   and product exchnage name
    const displayedPopUuids = new Set();
    const displayedExchangeNames = new Set();
    _.forEach(this.selectedCPopCols, (pop) => {
      _.forEach(this.exProducts, (prod) => {
        if (prod[pop.field]) {
          const hasVisibleItem = prod[pop.field].some(item => item.isDisplayed);
          if (hasVisibleItem) {
            displayedPopUuids.add(pop.field);
            displayedExchangeNames.add(prod.exchangeName);
          }
        }
      });
    });
    // Update lists to display
    this.defaultSelectedCPopCols = this.selectedCPopCols.filter(col =>
      displayedPopUuids.has(col.field)
    );
    this.defaultExProducts = this.exProducts.filter(prod =>
      displayedExchangeNames.has(prod.exchangeName)
    );
    this.updateRowGroupMetaData();
  }

  onHeaderCheckbox(event) {
    _.forEach(this.selectedCPopCols, (pop) => {
      _.forEach(this.exProducts, (prod) => {
        if (prod[pop.field]) {
          _.forEach(prod[pop.field], (item) => {
            item.isDisplayed = !!event.checked;
          });
        }
      });
    });
    if (event.checked) {
      this.defaultSelectedCPopCols = this.selectedCPopCols;
      this.defaultExProducts = this.exProducts;
    }
    this.updateRowGroupMetaData();
  }

  private getItemType(prod) {
    if (prod['isSfi']) {
      return {
        label: 'Streaming Frame Interface',
        value: 'assets/images/icons/sfi_icon.png',
        class: 'icon-sfi'
      };
    } else if (prod['isProtected'] && prod['isEncrypted']) {
      return {
        label: 'Encrypted and Protected',
        value: 'assets/images/icons/protected_encrypted_icon.png',
        class: 'icon-encrypted-protected'
      };
    } else if (prod['isProtected'] && !prod['isEncrypted']) {
      return {label: 'Protected', value: 'assets/images/icons/protected_icon.png', class: 'icon-protected'};
    } else if (!prod['isProtected'] && prod['isEncrypted']) {
      return {label: 'Encrypted', value: 'assets/images/icons/encrypted_icon.png', class: 'icon-encrypted'};
    } else if (prod['isArbitration']) {
      return {label: 'Arbitration', value: 'assets/images/icons/arbitrated_icon.png', class: 'icon-arbitrated'};
    } else {
      return {label: 'RF', value: 'assets/images/icons/rf_icon.png', class: 'icon-rf'};
    }
  }

  exportAsExcel() {
    this.errorExport = false;
    const service = this.service.toLowerCase();
    this.orderFormService.exportAsExcel(this.companyUniqid, service, this.displayedItemUuids()).subscribe({
        next: res => {
          const fileMimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          const blob = this.b64toBlob(res['file_content'], fileMimeType, null);
          saveAs(blob, res['file_name']);
          this.updateRowGroupMetaData();
        }, error: () => {
          this.errorExport = true;
        }
      }
    );
  }

  private displayedItemUuids(): string[] {
    let uuids = [];
    for (const key in this.exProducts) {
      if (Object.keys(this.exProducts[key]).length > 2) {
        const exProduct = this.exProducts[key];
        for (const i in exProduct) {
          if (Array.isArray(exProduct[i])) {
            const displayedUuids = exProduct[i].filter(obj => obj.isDisplayed === true).map(obj => obj.uuid);
            uuids = [...uuids, ...displayedUuids];
          }
        }
      }
    }
    return uuids;
  }

  private setTabTitle() {
    this.titleService.setTitle(`McKay Portal – ${this.getPageTitle(this.service).trim()} Profile`);
  }

  private b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || 'application/pdf';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }

  private getTypeImg(type: string) {
    if (type === 'SFI') {
      return 'assets/images/icons/sfi_icon.png';
    } else if (type === 'Encrypted and Protected') {
      return 'assets/images/icons/protected_encrypted_icon.png';
    } else if (type === 'Protected') {
      return 'assets/images/icons/protected_icon.png';
    } else if (type === 'Encrypted') {
      return 'assets/images/icons/encrypted_icon.png';
    } else if (type === 'Arbitration') {
      return 'assets/images/icons/arbitrated_icon.png';
    } else {
      return 'assets/images/icons/rf_icon.png';
    }
  }

  onCellHover(col: any, rowIndex: any): void {
    this.selectedCol = col;
    this.selectedRowIndex = rowIndex;
  }

  onCellLeave(): void {
    this.selectedCol = null;
    this.selectedRowIndex = null;
  }

  isColumnHighlighted(col: any): boolean {
    return this.selectedCol === col;
  }

  isRowHighlighted(rowIndex: number): boolean {
    return this.selectedRowIndex === rowIndex;
  }

  onGoingAnnoucements(exProduct: any, index) {
    if (exProduct[index]) {
      return exProduct[index].some((item) => item.onGoingAnnouncement === true);
    }
    return false;
  }

  onGoingOutage(exProduct: any, index) {
    if (exProduct[index]) {
      return exProduct[index].some((item) => item.onGoingOutage === true);
    }
    return false;
  }

  onGoingMaintenance(exProduct: any, index) {
    if (exProduct[index]) {
      return exProduct[index].some((item) => item.onGoingMaintenance === true);
    }
    return false;
  }

  gotoAnnoucementPage(uuids) {
    if (!uuids || uuids.length === 0) {
      return;
    }
    const userChoicesFiltersDefaultAnnouncementLog = {
      'subject': null,
      'message': null,
      'fromMail': null,
      'user': null,
      'sentDateFrom': null,
      'sentDateTo': null,
      'uuid': null,
    };
    const userChoicesActiveFilters = this.utilsService.loadUserPref('announcementLogFilter', userChoicesFiltersDefaultAnnouncementLog);
    userChoicesActiveFilters.uuid = uuids;
    this.utilsService.saveUserData('announcementLogFilter', userChoicesActiveFilters);
    this._router.navigate(['/' + this.getUserCurrent().company.uniqid + '/announcementLog']);
  }

  openSendJiraPopup() {
    if (!this.loggedInUser.permissions.isMckayUser) {
      this.prepareData();
    }
    this.isJirapopUp = true;
  }

  createIssue() {
    if (!this.selectedItemsForJira || this.selectedItemsForJira.length === 0 ||
      this.jiraCustomDescription.length === 0 ||
      (this.channelsDropDownList.length !== 0 &&
        (!this.selectedChannelsForJira || this.selectedChannelsForJira.length === 0))) {
      this.isSendToJiraDisabled = true;
      return;
    }
    this.isSendToJiraDisabled = false;
    this.jiraIssue.reporter = this.loggedInUser;
    this.jiraIssue.createdBy = this.loggedInUser.username;
    // Group items by crossConnectId
    const groupedItems = this.selectedItemsForJira.reduce((acc, selectedUuid) => {
      const selectedItem = this.itemsListForJira.find(item => item.value === selectedUuid);
      if (selectedItem) {
        if (!acc[selectedItem.crossConnectId]) {
          acc[selectedItem.crossConnectId] = [];
        }
        acc[selectedItem.crossConnectId].push(selectedItem);
      }
      return acc;
    }, {});
    // item description
    let itemDescription = `There seems to be an outage impacting the following items.\n Please investigate.\n\nService: ${this.service}\n\n`;
    Object.keys(groupedItems).forEach(crossConnectId => {
      const items = groupedItems[crossConnectId];
      const firstItem = items[0];
      // add the vlanId if not null
      let header = `*[${crossConnectId}`;
      if (firstItem && firstItem.vlanId) {
        header += ` | VLAN: ${firstItem.vlanId}`;
      }
      header += `]*\n`;

      itemDescription += header;
      items.forEach(item => {
        itemDescription += `- ${item.name} @ ${item.cPop}/${item.technicalPop}\n`;
      });
      itemDescription += '\n';
    });
    const selectedXcos = Object.keys(groupedItems).filter(xcoId => xcoId);
    const xcoList = selectedXcos.join(', ');
    this.jiraIssue.subject = 'Issue impacting ' + this.service + ' service on [' + xcoList + ']';
    // company name
    const companyNameDescription = 'Company Name: ' + this.loggedInUser.company.name + '\n';
    // impacted channels description
    let channelsDescription = `*Impacted Channels:* \n`;
    channelsDescription += this.selectedChannelsForJira.map(channel => `- ${channel.channelCode}`).join('\n');
    channelsDescription += '\n \n';
    // add the description of the user
    let finalDescription = `${itemDescription}${channelsDescription}${companyNameDescription} *Customer addl comment:* \n${this.jiraCustomDescription}`;
    finalDescription = finalDescription.replace(/<br\s*\/?>/g, '\n')
      .replace(/<\/p>\s*<p>/g, '\n')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ').trim(); // to prevent having  nbsp on jira description
    // Jira issue data
    const jiraIssueData = {
      description: finalDescription,
      subject: this.jiraIssue.subject,
      participantEmail: this.selectedParticipantForJira,
      createdByUserName: this.jiraIssue.reporter.username,
      createdByEmail: this.jiraIssue.reporter.email,
      isSupport: this.selectedPriority === 'support',
      isQuincyProject: true,
      isMckayProject: false,
    };
    this.utilsService.lockUi();
    // Create Jira issue
    this.jiraService.createJiraIssue(jiraIssueData).subscribe({
      next: (response) => {
        // this.isSendToJiraDisabled= true
        this.successCreateJira = true;
        this.jiraIssueCode = response['created_issue_key'];
        this.jiraLink = response['jira_link'];
        this.isJirapopUp = false;
        this.utilsService.unlockUi();
      },
      error: () => {
        this.jiraCreationError = true;
        this.isJirapopUp = false;
        this.utilsService.unlockUi();
      }
    });
  }

  onSelectItemUpdateValues() {
    this.setChannelsList();
    this.isSendToJiraDisabled = false;

  }

  setIsSendToJiraFlag() {
    this.isSendToJiraDisabled = false;
  }

  cancel() {
    this.isJirapopUp = false;
    this.jiraCustomDescription = '';
  }

  getConfigureItemsUUIDs(products: ExchangeProduct[]): any[] {
    const uuids = [];
    products.forEach(product => {
      for (const key in product) {
        if (Array.isArray(product[key])) {
          product[key].forEach((item: any) => {
            if (item.status === 'Configured') {
              uuids.push(item.uuid);
            }
          });
        }
      }
    });
    return uuids;
  }

  setItemsForJira() {
    this.itemsListForJira = [];
    const criteria = {
      companyUniqid: this.companyUniqid,
      service: this.service.toLowerCase(),
      itemUuids: this.getConfigureItemsUUIDs(this.exProducts)
    };
    // Getting only configured Items
    this.orderFormService.getOrderFormsItems(criteria).subscribe(result => {
      // Group items by crossConnectId and technicalPop
      const groupedItems = result['itemsData'].reduce((acc: any, res: any) => {
        const key = `${res.crossConnectId}_${res.technicalPop}`;
        if (!acc[key]) {
          acc[key] = {
            crossConnectId: res.crossConnectId, technicalPop: res.technicalPop, items: []
          };
        }
        acc[key].items.push({
          label: `${res.productName} @ ${res.commercialPop}`, value: res.uuid
        });
        return acc;
      }, {});
      this.itemsDataForDropDown = Object.values(groupedItems);
      this.itemsDataForDropDown.sort((a: any, b: any) => {
        const [crossConnectA, techPopA] = [a.crossConnectId, a.technicalPop];
        const [crossConnectB, techPopB] = [b.crossConnectId, b.technicalPop];
        if (crossConnectA < crossConnectB) {
          return -1;
        }
        if (crossConnectA > crossConnectB) {
          return 1;
        }
        if (techPopA < techPopB) {
          return -1;
        }
        if (techPopA > techPopB) {
          return 1;
        }
        return 0;
      });
      this.itemsDropDownOptions = this.transformDataToMultiSelect(this.itemsDataForDropDown);
      this.addSearchOptionToDropdown(this.itemsDropDownOptions);
      // set all the items List
      result['itemsData'].forEach((res: any) => {
        this.itemsListForJira.push({
          name: res.productName,
          value: res.uuid,
          cPop: res.commercialPop,
          carrier: res.carrier,
          hosting: res.hosting,
          crossConnectId: res.crossConnectId,
          technicalPop: res.technicalPop,
          channels: res.channels,
          vlanId: res.vlanId,
        });
      });
    });
  }
   addSearchOptionToDropdown(options: any[]) {
    options.forEach(option => {
      const parentLabel = option.label ?? '';
      const childrenLabels = option.value?.childOptions
        ?.map(child => child.label)
        .join(' ') ?? '';
      option.searchText = `${parentLabel} ${childrenLabels}`
        .toLowerCase()
        .replace(/[^a-z0-9\s]/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    });
  }

  fillSelectedItems(event) {
    this.selectedItemsForJira = [];
    this.prepareSelectedItems(event, this.selectedItemsForJira);
    this.onSelectItemUpdateValues();
  }

  fillSelectedChannel(event) {
    this.selectedChannelsForJira = [];
    this.isSendToJiraDisabled = false;
    this.prepareSelectedItems(event, this.selectedChannelsForJira);
  }

  private transformDataToMultiSelect(data: any[]): SelectItem[] {
    return data.map(item => ({
      label: item.crossConnectId, value: {
        id: item.crossConnectId, selectedChildOptions: [], childOptions: item.items.map(child => ({
          label: child.label, value: child.value
        }))
      }
    }));
  }

  private setChannelsList() {
    const groupedChannels: any = {};

    this.selectedItemsForJira.forEach((selectedUuid: any) => {
      const selectedItem = this.itemsListForJira.find(item => item.value === selectedUuid);

      if (selectedItem && selectedItem.channels.length) {
        const groupKey = `${selectedItem.crossConnectId}_${selectedItem.technicalPop}`;

        if (!groupedChannels[groupKey]) {
          groupedChannels[groupKey] = {
            crossConnectId: selectedItem.crossConnectId,
            technicalPop: selectedItem.technicalPop,
            channels: [],
            _channelSet: new Set()
          };
        }

        selectedItem.channels.forEach(channel => {
          if (channel.platform === 'uat') {
            return;
          }
          const channelKey = `${channel.channelCode}_${channel.platform}`;
          if (groupedChannels[groupKey]._channelSet.has(channelKey)) {
            return;
          }
          groupedChannels[groupKey]._channelSet.add(channelKey);
          groupedChannels[groupKey].channels.push({
            label: `${channel.channelCode}-${channel.platform}`,
            value: channel
          });
        });
      }
    });

    this.channelsDropDownList = Object.values(groupedChannels).map((group: any) => {
      delete group._channelSet;
      return group;
    });

    this.channelsDropDownList.sort((a: any, b: any) => {
      const [crossConnectA, techPopA] = [a.crossConnectId, a.technicalPop];
      const [crossConnectB, techPopB] = [b.crossConnectId, b.technicalPop];
      if (crossConnectA < crossConnectB) {
        return -1;
      }
      if (crossConnectA > crossConnectB) {
        return 1;
      }
      if (techPopA < techPopB) {
        return -1;
      }
      if (techPopA > techPopB) {
        return 1;
      }
      return 0;
    });
    this.channelsDropDownOptions = this.transformChannelsToMultiSelect(this.channelsDropDownList);
  }



  private transformChannelsToMultiSelect(data: any[]): SelectItem[] {
    return data.map(item => ({
      label: item.crossConnectId, value: {
        id: item.technicalPop, selectedChildOptions: [], childOptions: item.channels.map(child => ({
          label: child.label, value: child.value
        }))
      }
    }));
  }

  private prepareSelectedItems(event: any, list: number[]) {
    event.parentOptions.forEach((item) => {
      item.value.selectedChildOptions.forEach((item) => {
        list.push(item);
      });
    });
    event.childOptions.forEach((item) => {
      list.push(item);
    });
  }

  loadMulticasts() {
    this.orderFormService.getMulticasts(this.companyUniqid, this.service.toLowerCase()).subscribe(data => {
      Object.keys(data).forEach(status => {
        Object.keys(data[status]).forEach(xcoId => {
          data[status][xcoId] = this.sortByIp(data[status][xcoId]);
        });
      });
      this.multicastGroups = data;
    });
  }

  sortByIp(list: string[]): string[] {
    return list.sort((a, b) => {
      const ipA = a.split(' : ')[0].split('.').map(Number);
      const ipB = b.split(' : ')[0].split('.').map(Number);
      for (let i = 0; i < 4; i++) {
        if (ipA[i] !== ipB[i]) {
          return ipA[i] - ipB[i];
        }
      }
      return 0;
    });
  }

  isQfdService(): boolean {
    return this.service.toUpperCase() === 'QFD';
  }

  showMulticastGroups() {
    if (!this.isQfdService()) {
      this.displayMulticastDialog = true;
    }
  }

  copyMulticasts(status: string) {
    const multicasts = this.multicastGroups[status];
    let copyText = '';

    Object.keys(multicasts).forEach(xcoId => {
      copyText += `${xcoId}\n`;
      multicasts[xcoId].forEach(multicast => {
        copyText += `${multicast}\n`;
      });
    });

    this.copyToClipboard(copyText);
    this.copiedStatus = status;
    setTimeout(() => {
      if (this.copiedStatus === status) {
        this.copiedStatus = null;
      }
    }, 2000);
  }


  openConfigPopup() {
    this.showConfigPopup = true;
    this.loadingConfigs = true;
    this.configsFailed = false;
    this.orderFormService.getPopConfigs(this.companyUniqid, this.service.toLowerCase()).subscribe({
      next: response => {
        this.configsByPop = response.pops || [];
        this.loadingConfigs = false;
      },
      error: () => {
        this.configsByPop = [];
        this.configsFailed = true;
        this.loadingConfigs = false;
      }
    });
  }

  connectionName(config: PopConfiguration): string {
    if (config.crossConnectId) {
      return config.crossConnectId;
    }
    if (config.vlanId) {
      return 'VLAN ' + config.vlanId;
    }

    return 'POP configuration';
  }

  toggleTargetConfig(config: PopConfiguration) {
    this.expandedTargetId = this.expandedTargetId === config.configId ? null : config.configId;
  }

  targetConfigId(config: PopConfiguration): string {
    return config.configId + ':target';
  }

  copyConfig(config: PopConfiguration) {
    this.copyConfigText(config.currentConfig, config.configId);
  }

  copyTargetConfig(config: PopConfiguration) {
    this.copyConfigText(config.targetConfig, this.targetConfigId(config));
  }

  copyConfigText(text: string, id: string) {
    this.copyToClipboard(text);
    this.copiedId = id;
    setTimeout(() => {
      if (this.copiedId === id) {
        this.copiedId = null;
      }
    }, 2000);
  }

  copyToClipboard(text: string) {
    const textarea = document.createElement('textarea');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  hasMulticasts(status: string): boolean {
    return this.multicastGroups[status] && Object.keys(this.multicastGroups[status]).length > 0;
  }

  private prepareData() {
    const currentUserEmail = this.loggedInUser.email;
    this.etreeService.getOperationUser(this.getUserCurrent().company.id).subscribe({
      next: (response) => {
        this.participantsItemForJira = response.map(user => ({
          label: user.username, value: user.email, id: user.id, disabled: user.email === currentUserEmail
        }));
        this.participantsItemForJira = _.sortBy(this.participantsItemForJira, ['label']);
        this.selectedParticipantForJira = this.participantsItemForJira
          .filter(user => user.disabled)
          .map(user => user.value);
      }, error: () => {
        this.jiraCreationError = true;
      }
    });
  }

  getChannelsColumns(service: string, layer?: number | string): any[] {
    if (service === 'QED') {
      return this.channelCols.QED;
    }
    if (service === 'QHF') {
      return this.channelCols.QHF;
    }
    if (service === 'QRD') {
      return layer === 'layer1' ? this.channelCols.QRD_L1 : this.channelCols.QRD_L3;
    }
    if (service === 'NEWS') {
      return this.channelCols.NEWS;
    }
    return [];
  }


  enableFullGrid() {
    this.showFullGrid = !this.showFullGrid;
    if (this.showFullGrid) {
      this.defaultSelectedCPopCols = this.selectedCPopCols;
      this.defaultExProducts = this.exProducts;
    } else {
      if (this.hasOnlyInactiveOF) {
        this.displayedPopAndProdAccordingToVisibleItems();
      } else {
        this.defaultSelectedCPopCols = this.selectedCPopCols.filter(c => c.displayed);
        this.defaultExProducts = this.exProducts.filter(p => p.displayed);
      }
    }
    this.updateRowGroupMetaData();
  }

  private displayedPopAndProdAccordingToVisibleItems() {
    const displayedPopUuids = new Set();
    const displayedExchangeNames = new Set();
    for (const pop of this.selectedCPopCols) {
      for (const prod of this.exProducts) {
        if (prod[pop.field]) {
          const hasVisibleItem = prod[pop.field].some(item => item.isDisplayed);
          if (hasVisibleItem) {
            displayedPopUuids.add(pop.field);
            displayedExchangeNames.add(prod.exchangeName);
          }
        }
      }
    }
    this.defaultSelectedCPopCols = this.selectedCPopCols.filter(col => displayedPopUuids.has(col.field));
    this.defaultExProducts = this.exProducts.filter(prod => displayedExchangeNames.has(prod.exchangeName));
  }

  isAlreadyCondensed() {
    return (this.exProducts.length < 12 && this.selectedCPopCols.length < 12);
  }

  getClassForCategory(announcementCategory: any) {
    return this.utilsService.getClassForAnnouncementCategory(announcementCategory);
  }

  getPageTitle(service: string): string {
    switch (service) {
      case 'QED':
        return 'Snapshot:';
      case 'QRD':
        return 'Raw:';
      case 'QFD':
        return 'Price&Volume Signals:';
      case 'QHF':
        return 'Volume Signals:';
      case 'NEWS':
        return 'News:';
      default:
        return '';
    }
  }

  calculateRowSpan(crossConnectId: string, rows: any[]): number {
    return rows.filter(r => r.crossConnectId === crossConnectId).length;
  }

  isFirstOccurrence(rowIndex: number, crossConnectId: string, rows: any[]): boolean {
    return rows.findIndex(r => r.crossConnectId === crossConnectId) === rowIndex;
  }

  getColumnWidth(columns: any[], field: string): string {
    const col = columns.find(c => c.field === field);
    return col ? col.width : 'auto';
  }

  getLabelFromAnnouncementCategory(announcementCategory: any) {
    if (announcementCategory === 'client_action_required') {
      return 'Client action required';
    }
    if (announcementCategory === 'emergency_maintenance') {
      return 'Emergency maintenance';
    }
    if (announcementCategory === 'scheduled_maintenance') {
      return 'Scheduled maintenance';
    }
    if (announcementCategory === 'service_change') {
      return 'Service change';
    }
    if (announcementCategory === 'marketing') {
      return 'Marketing';
    }
    return 'Ongoing announcement';
  }

  channelsHaveLayer(channels: any, layer: string) {
    return channels.some(channel => channel.layer === layer);
  }

  getLayerlines(channels: any, layer: string) {
    channels = channels.filter(channel => channel.layer === layer);
    return channels;
  }
}
